import _ from 'lodash'

/**
 *
 * @param str
 * @returns {string}
 */
export default (str = '') => {
  return str
    ? _.snakeCase(str) + '_' + Math.random().toString(36).substr(2, 6)
    : Math.random().toString(36).substr(2, 6)
}
